<template>
  <div class="container">
    <div class="top_title">活动签到码</div>
    <div class="scroll_area" style="overflow-y: auto">
      <div class="selection_condition_title" style="margin-top: 2.6rem">
        <span class="icon_selection_condition"></span>
        <span>筛选条件</span>
      </div>
      <div class="selection_items">
        <div class="weui-cells item">
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>参加校区(含)</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="currentSchool">
                <option value=''>请选择</option>
                <option v-for="school in schoolList" :value='school.I_SCHOOL_NO'>{{school.I_SCHOOL_NAME}}</option>
              </select>
            </div>
          </div>
          <div class="weui-cell weui-cell_select weui-cell_select-after">
            <div class="weui-cell__bd">
              <p>活动主题</p>
            </div>
            <div class="weui-cell__ft">
              <select class="weui-select" style="color:#bbb" v-model="currentTheme">
                <option value=''>请选择</option>
                <option v-for="theme in themeList" :value='theme.I_ACTIVITY_NO_SYS'>{{theme.I_TITLE}}</option>
              </select>
            </div>
          </div>
          <button class="bottom_btn" @click="createQrCode">生成签到二维码</button>
        </div>
      </div>

      <div v-if="info.I_QR_URL != ''" class="QRcode_info_title">
        <span class="icon_QRcode_info"></span>
        <span>二维码</span>
      </div>
      <div v-if="info.I_QR_URL != ''" class="QRcode_aera">
        <img :src="info.I_QR_URL" />
        <p>{{info.I_INFO}}</p>
      </div>

    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        info: {
          I_QR_URL: ""
        },
        schoolList: [],
        currentSchool: "",
        themeList: [],
        currentTheme: "",
      }
    },
    components: {
      Footer
    },
    created() {
      let vm = this
      DataRequestFactory.C010010().then((response) => {
          vm.schoolList = response.dataList
      })
    },
    methods: {
      createQrCode() {
        let param = {
          I_ACTIVITY_NO_SYS: this.currentTheme
        }
        DataRequestFactory.I300031(param).then((response) => {
          this.info = response
      })
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 3
      $(".scroll_area").css("height", heightDiff + "px"   )
    },
    watch: {
      currentSchool (val) {
        if(val == "") {
          this.classList = []
        } else {
          let param = {
            I_SCHOOL_NO: val
          }
          DataRequestFactory.I300030(param).then((response) => {
            this.themeList = response.dataList
        })
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H300030.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H300030.vue